var render = function render(){var _vm=this,_c=_vm._self._c;return _c('connector-wizard-widget',{staticClass:"search-connector-styles",on:{"go-to-connector":_vm.goToConnector,"go-to-dashboard":_vm.goToDashboard}})
}
var staticRenderFns = []

export { render, staticRenderFns }